module.exports = __webpack_public_path__ + "hstl2-9e6faf8a.webp";